<div class="quick-apply-container">
  <app-talent-happy-path-header
    [headerText]="postingInfo ? postingInfo.jobTitle : 'talent-happy-path.welcome-text' | translate">
  </app-talent-happy-path-header>
  <div class="container-body">
    <div class="thank-you-container">
      <div class="thank-you-message">
        @if (postingInfo) {
          <h3>{{ 'talent-happy-path.job-posting-closed-page.no-longer-available' | translate }}</h3>
        } @else {
          <h3>{{ 'talent-happy-path.job-posting-closed-page.job-not-found' | translate }}</h3>
        }
      </div>
      <a mat-flat-button color="primary" class="continue-button single-custom-button thank-you-button"
         [href]="jobBoardUrl">
        {{ "talent-happy-path.job-posting-closed-page.button" | translate }}
      </a>
    </div>
  </div>
  <app-talent-happy-path-footer class="talent-profile-footer"></app-talent-happy-path-footer>
</div>
